/**
 * TUAC 缺省值 Context：从 tuac_core.inf 读取 [tuacgui] 与 [tuac] 段，供 MusicPlayer 与 TUAC 引擎使用。
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchTuacDefaults, getHardcodedDefaults, getHardcodedTuacParams } from './tuacDefaults';

const defaultContextValue = {
  playerDefaults: getHardcodedDefaults(),
  tuacParams: getHardcodedTuacParams()
};

const TuacDefaultsContext = createContext(defaultContextValue);

const LOAD_TIMEOUT_MS = 3000;

export function TuacDefaultsProvider({ children }) {
  const [value, setValue] = useState(() => defaultContextValue);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timeoutId = setTimeout(() => {
      if (cancelled) return;
      setReady(true);
    }, LOAD_TIMEOUT_MS);

    fetchTuacDefaults()
      .then((d) => {
        if (!cancelled) {
          setValue({
            playerDefaults: d.defaults,
            tuacParams: d.tuacParams
          });
          setReady(true);
        }
      })
      .catch(() => {
        if (!cancelled) setReady(true);
      });

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, []);

  if (!ready) return null;
  return (
    <TuacDefaultsContext.Provider value={value}>
      {children}
    </TuacDefaultsContext.Provider>
  );
}

export function useTuacDefaults() {
  return useContext(TuacDefaultsContext);
}
